export default __webpack_public_path__ + "static/media/celebration-animation.0109e796.gif";